import { gql } from '@apollo/client';

export const SHARED_ACADEMIC_FIELDS = `
      id
      academicProperties {
        email
        isRequested
        isApproved
        isRejected
        rejectedReason
        university
        department
        email
        webpage
        address
        address1
        address2
        postcode
        town
        county
        countryId
      }
`;

export const GET_USER = gql`
  query getUser($id: String!) {
    user: getUser(id: $id) {
      ${SHARED_ACADEMIC_FIELDS}
    }
  }
`;
